import { useEffect, useState } from 'react';
import { listLeadReferrals } from 'services/leadServices';

export function useLeadReferralList() {
  const [List, setList] = useState([]);

  const loadLeadReferrals = () => {
    listLeadReferrals()
      .then((res) => setList(res.data || []))
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    loadLeadReferrals();
  }, []);

  return { leadReferralsList: List, loadLeadReferrals };
}
